module.exports = __webpack_public_path__ + "static/media/elibrary.6c16d685.webp";